export type VISeriesTypesEnum = VISummarySeriesTypesEnum;

export enum VISummarySeriesTypesEnum {
    brandScoreAvg,
    brandScoreAvgPP,
    brandScoreTrend,

    competitiveScoreAvg,
    competitiveScoreTrend,

    visibilityScoreAvg,
    visibilityScoreAvgPP,
    visibilityScoreTrend,

    presenceRateAvg,
    presenceRateAvgPP,
    presenceRateTrend,

    rankWhenListedAvg,
    rankWhenListedAvgPP,
    rankWhenListedTrend,

    sentimentScoreAvg,
    sentimentScoreAvgPP,
    sentimentScoreTrend,

    accuracyScoreAvg,
    accuracyScoreAvgPP,
    accuracyScoreTrend,

    riskRateAvg,
    riskRateAvgPP,
    riskRateTrend,

    citationPerScanAvg,
    citationPerScanAvgPP,
    citationPerScanTrend
};
